import { render, staticRenderFns } from "./TermRestrictedChoiceSlidebar.vue?vue&type=template&id=576e2086"
import script from "./TermRestrictedChoiceSlidebar.vue?vue&type=script&lang=js"
export * from "./TermRestrictedChoiceSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports